import { inject, Pipe, PipeTransform } from "@angular/core";
import { TranslationService } from "@core-services/translation.service";

@Pipe({
	name: "security_token_unit",
	standalone: false
})
export class SecurityTokenUnitPipe implements PipeTransform {
	private translationService = inject(TranslationService);

	transform(value: string): string {
		if (+value !== 1) {
			const units = this.translationService.translate("fma_unit_other");
			return value.toString() + units;
		}
		const unit = this.translationService.translate("fma_unit_one");
		return value.toString() + unit;
	}
}
